import { render, staticRenderFns } from "./Addrelevancy.vue?vue&type=template&id=27d2e3d4&"
import script from "./Addrelevancy.vue?vue&type=script&lang=js&"
export * from "./Addrelevancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports